module.exports = __webpack_public_path__ + "img/ring_g_skip_1_null@2x.e02f1525.png";